import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const HISTORICALPEDESTRIANVOLUME_LAYER_ID = 'historicalPedestrianVolumeLayer';

const layerConfig = {
  title: 'Pedestrian Volume',
};

function HistoricalPedestrianVolumeLayer() {
  const dispatch = useDispatch();
  const { historicalPedestrianVolumeLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, historicalPedestrianVolumeLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });
   const viewState = useSelector((state) => state.carto.viewState);
  const pointLineWidth = viewState.zoom >= 7 ? 2 : 1;

  if (historicalPedestrianVolumeLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HISTORICALPEDESTRIANVOLUME_LAYER_ID,
      geoColumn: 'geom',
      stroked: false,
      filled: true,
      lineWidthMinPixels: pointLineWidth,
      lineWidthMaxPixels: 10,
      getLineColor: colorBins({
        attr: 'Pedestrian_Volume',
        domain: [25, 50, 100, 200],
        colors: [
          [15, 133, 84, 64],
          [15, 133, 84, 128],
          [15, 133, 84, 192],
          [15, 133, 84, 255],
        ],
      }),
    
      coverage: 0.95,
      pickable: true,
      visible: historicalPedestrianVolumeLayer.visible,
      opacity: historicalPedestrianVolumeLayer.opacity,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HISTORICALPEDESTRIANVOLUME_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
              if (info?.object) {
                info.object = {
                  html: htmlForFeature({
                    feature: info.object,
            }),
          };
        }
      },
    });
  }
}

export default HistoricalPedestrianVolumeLayer;
